import { EXPONDO_SKU_PREFIX } from '~/constants/products';

export const removeProductSkuPrefix = (sku: string): string => {
  if (sku) {
    return sku.replace(EXPONDO_SKU_PREFIX, '');
  }
  return '';
};
